import { Page } from '@ui/themed';
import { t } from 'i18next';
import { withPageProviders } from '../../../context/page-context';
import { CustomersSearchTable } from '../components/customers-search-table';
import { CustomerSyncStatusAlert } from '../components/customers-sync-log-alert';
import { CUSTOMER_ROLE_TYPE } from '../constants';

export const CustomerCompaniesOverviewPage = withPageProviders(() => {
  return (
    <Page
      title={t('features:customers.pages.list_page.title')}
      description={t('features:customers.pages.list_page.description')}
      learnMoreUrl="https://docs.sparklayer.io/customers"
      footerDescription={t('features:customers.pages.list_page.footer')}
    >
      <CustomerSyncStatusAlert />
      <CustomersSearchTable
        baseSearchRequest={{ role_type: CUSTOMER_ROLE_TYPE.CUSTOMER }}
        caption={t('features:customers.pages.list_page.customers_table.caption')}
        emptyState={{
          title: t('features:customers.pages.list_page.empty_state.title'),
          subtitle: t('features:customers.pages.list_page.empty_state.subtitle'),
        }}
      />
    </Page>
  );
});
